import { Component, Input, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { ActionLabels, TermsAndCondtionsType, MarketplaceItemStockType, ProcessProviderId, MarketplaceItemStatus, MarketplaceExtendedQuery, CardTokenQuery, MemberQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { tap, takeUntil, map } from 'rxjs/operators';
import { MarketplaceActionsComponent, MarketplaceActionsModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details/marketplace-actions';
import { Router } from '@angular/router';
import { TranslateService, TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { MarketplaceAttributesModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details/marketplace-attributes';
import { MarketplaceCustomFieldsModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details/marketplace-custom-fields';
import { MarketplacePurchaseConfirmationModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details/marketplace-purchase-confirmation';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@ngx-translate/core';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details/marketplace-attributes';
import * as ɵngcc8 from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details/marketplace-custom-fields';
import * as ɵngcc9 from '@angular/forms';
import * as ɵngcc10 from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details/marketplace-actions';
import * as ɵngcc11 from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import * as ɵngcc12 from '@fgb/portal-component-library/src/lib/shared/loading';
import * as ɵngcc13 from '@fgb/portal-component-library/src/lib/pipes';

function MarketplaceDetailsComponent_div_0_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "span", 24);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3, "attach_money");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 25);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 2, "marketplace.details.ecash.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 4, item_r2.EcashValue));
} }
function MarketplaceDetailsComponent_div_0_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "span", 24);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3, "attach_money");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 26);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "FortressCurrencyPipe");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 2, "marketplace.merchant.price.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 4, item_r2.MerchantValue / 100));
} }
function MarketplaceDetailsComponent_div_0_ng_container_22_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "span", 27);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3, "local_offer");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 28);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 3, "marketplace.stock.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r14.availableStock, "/", ctx_r14.stockCount, " ");
} }
function MarketplaceDetailsComponent_div_0_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MarketplaceDetailsComponent_div_0_ng_container_22_div_1_Template, 6, 5, "div", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r2.ComingSoon);
} }
function MarketplaceDetailsComponent_div_0_fgbcl_marketplace_custom_fields_24_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "fgbcl-marketplace-custom-fields", 29);
    ɵngcc0.ɵɵlistener("customFieldsChange", function MarketplaceDetailsComponent_div_0_fgbcl_marketplace_custom_fields_24_Template_fgbcl_marketplace_custom_fields_customFieldsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.setCustomFields($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("itemCustomFields", item_r2.CustomFields)("hasSumbittedForm", ctx_r6.hasSumbittedForm);
} }
function MarketplaceDetailsComponent_div_0_div_25_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 37);
    ɵngcc0.ɵɵlistener("click", function MarketplaceDetailsComponent_div_0_div_25_a_8_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(3); return ctx_r21.showTermsAndConditonsActive(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "marketplace.terms.tcs"), " ");
} }
function MarketplaceDetailsComponent_div_0_div_25_a_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("href", ctx_r20.termsLink, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, "marketplace.terms.tcs"), " ");
} }
function MarketplaceDetailsComponent_div_0_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 30);
    ɵngcc0.ɵɵelementStart(2, "input", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function MarketplaceDetailsComponent_div_0_div_25_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.termsAccepted = $event; })("ngModelChange", function MarketplaceDetailsComponent_div_0_div_25_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.marketplaceActionsComponent.updateTermsAndCondtions($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 32);
    ɵngcc0.ɵɵelementStart(4, "label", 33);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 34);
    ɵngcc0.ɵɵtemplate(8, MarketplaceDetailsComponent_div_0_div_25_a_8_Template, 3, 3, "a", 35);
    ɵngcc0.ɵɵtemplate(9, MarketplaceDetailsComponent_div_0_div_25_a_9_Template, 3, 4, "a", 36);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.termsAccepted);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(6, 4, "marketplace.terms.accept"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.marketplaceItem.TermsAndConditionsType === ctx_r7.TermsAndCondtionsType.Text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.marketplaceItem.TermsAndConditionsType === ctx_r7.TermsAndCondtionsType.URL);
} }
function MarketplaceDetailsComponent_div_0_fgbcl_marketplace_actions_26_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "fgbcl-marketplace-actions", 39);
    ɵngcc0.ɵɵlistener("purchaseLoading", function MarketplaceDetailsComponent_div_0_fgbcl_marketplace_actions_26_Template_fgbcl_marketplace_actions_purchaseLoading_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.updateLoading($event); })("hasSumbittedForm", function MarketplaceDetailsComponent_div_0_fgbcl_marketplace_actions_26_Template_fgbcl_marketplace_actions_hasSumbittedForm_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.submitForm(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("marketplaceItem", item_r2)("marketplaceItemType", ctx_r8.marketplaceItemType)("attributeMappingID", ctx_r8.attributeMappingID)("selectedAttributes", ctx_r8.selectedAttributes)("validCustomFields", ctx_r8.validCustomFields)("hasECash", ctx_r8.hasECash())("theme", ctx_r8.theme)("actionLabels", ctx_r8.actionLabels)("availableStock", ctx_r8.availableStock);
} }
function MarketplaceDetailsComponent_div_0_li_33_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 40);
    ɵngcc0.ɵɵlistener("click", function MarketplaceDetailsComponent_div_0_li_33_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.showTermsAndConditonsActive(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r9.showTermsAndConditionsText ? "text-primary" : "text-info");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, "marketplace.item.tcs"), " ");
} }
function MarketplaceDetailsComponent_div_0_div_35_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "fgbcl-short-long-description", 41);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("description", item_r2.DescriptionText);
} }
function MarketplaceDetailsComponent_div_0_div_36_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "fgbcl-short-long-description", 43);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext(2).ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("description", item_r2.TermsAndConditions);
} }
function MarketplaceDetailsComponent_div_0_div_36_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 44);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext(2).ngIf;
    ɵngcc0.ɵɵproperty("href", item_r2.TermsAndConditions, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r2.TermsAndConditions);
} }
function MarketplaceDetailsComponent_div_0_div_36_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, MarketplaceDetailsComponent_div_0_div_36_div_1_Template, 2, 1, "div", 0);
    ɵngcc0.ɵɵtemplate(2, MarketplaceDetailsComponent_div_0_div_36_a_2_Template, 2, 2, "a", 42);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.marketplaceItem.TermsAndConditionsType === ctx_r11.TermsAndCondtionsType.Text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.marketplaceItem.TermsAndConditionsType === ctx_r11.TermsAndCondtionsType.URL);
} }
function MarketplaceDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelement(4, "img", 4);
    ɵngcc0.ɵɵpipe(5, "contentImage");
    ɵngcc0.ɵɵelementStart(6, "div", 5);
    ɵngcc0.ɵɵelement(7, "fgbcl-loyalty-icon", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "h2", 8);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵelementStart(12, "div", 10);
    ɵngcc0.ɵɵelementStart(13, "div", 11);
    ɵngcc0.ɵɵelementStart(14, "span", 12);
    ɵngcc0.ɵɵpipe(15, "translate");
    ɵngcc0.ɵɵtext(16, "emoji_events");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "span", 13);
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵpipe(19, "FortressCurrencyPipe");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(20, MarketplaceDetailsComponent_div_0_div_20_Template, 7, 6, "div", 14);
    ɵngcc0.ɵɵtemplate(21, MarketplaceDetailsComponent_div_0_div_21_Template, 7, 6, "div", 14);
    ɵngcc0.ɵɵtemplate(22, MarketplaceDetailsComponent_div_0_ng_container_22_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "fgbcl-marketplace-attributes", 15);
    ɵngcc0.ɵɵlistener("attributeMapping", function MarketplaceDetailsComponent_div_0_Template_fgbcl_marketplace_attributes_attributeMapping_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const item_r2 = ctx.ngIf; const ctx_r37 = ɵngcc0.ɵɵnextContext(); return ctx_r37.onAttributeValueChange(item_r2, $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(24, MarketplaceDetailsComponent_div_0_fgbcl_marketplace_custom_fields_24_Template, 1, 2, "fgbcl-marketplace-custom-fields", 16);
    ɵngcc0.ɵɵtemplate(25, MarketplaceDetailsComponent_div_0_div_25_Template, 10, 6, "div", 0);
    ɵngcc0.ɵɵtemplate(26, MarketplaceDetailsComponent_div_0_fgbcl_marketplace_actions_26_Template, 1, 9, "fgbcl-marketplace-actions", 17);
    ɵngcc0.ɵɵelementStart(27, "nav", 18);
    ɵngcc0.ɵɵelementStart(28, "div", 19);
    ɵngcc0.ɵɵelementStart(29, "ul", 20);
    ɵngcc0.ɵɵelementStart(30, "li", 21);
    ɵngcc0.ɵɵlistener("click", function MarketplaceDetailsComponent_div_0_Template_li_click_30_listener() { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ctx_r39.showDescriptionActive(); });
    ɵngcc0.ɵɵtext(31);
    ɵngcc0.ɵɵpipe(32, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(33, MarketplaceDetailsComponent_div_0_li_33_Template, 3, 4, "li", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(34, "hr", 23);
    ɵngcc0.ɵɵtemplate(35, MarketplaceDetailsComponent_div_0_div_35_Template, 2, 1, "div", 0);
    ɵngcc0.ɵɵtemplate(36, MarketplaceDetailsComponent_div_0_div_36_Template, 3, 2, "div", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.ngIf;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind3(5, 24, item_r2.ItemImageURL, "7", "marketplace"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("alt", item_r2.DisplayName)("useDefault", true)("loyaltyType", "marketplace");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassMapInterpolate2("corner-icon ", "bg-" + item_r2.theme, " ", "text-on-" + item_r2.theme, "");
    ɵngcc0.ɵɵproperty("loyaltyType", item_r2.ProcessProviderId);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r2.DisplayName);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(15, 28, "marketplace.points.value.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(19, 30, item_r2.PointValue, "PTS"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasECash());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasMerchant());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showStock);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("marketplaceItem", item_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r2.CustomFields && item_r2.CustomFields.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.marketplaceItem.ShowTermsAndConditions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.showDescription ? "text-primary" : "text-info");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(32, 33, "marketplace.item.description"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.marketplaceItem.ShowTermsAndConditions);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showDescription);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showTermsAndConditionsText);
} }
function MarketplaceDetailsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 45);
    ɵngcc0.ɵɵelement(2, "fgbcl-loading");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
class MarketplaceDetailsComponent {
    constructor(marketplaceExtendedQuery, cardTokenQuery, memberQuery, router, translate) {
        this.marketplaceExtendedQuery = marketplaceExtendedQuery;
        this.cardTokenQuery = cardTokenQuery;
        this.memberQuery = memberQuery;
        this.router = router;
        this.translate = translate;
        this.actionLabels = ActionLabels;
        this.cardTokenCount = 0;
        this.termsAccepted = false;
        this.TermsAndCondtionsType = TermsAndCondtionsType;
        this.showTermsAndConditionsText = false;
        this.showDescription = true;
        this.loading = false;
        this.backLink = '/rewards/marketplace';
        this.hasSumbittedForm = false;
        this.validCustomFields = [];
        this.showStock = true;
        this._destroyed$ = new Subject();
    }
    ngOnInit() {
        this.cardTokenQuery
            .selectUnfrozenCards()
            .pipe(tap((tokens) => (this.cardTokenCount = tokens.length)))
            .toPromise();
        this.marketplaceItem$ = this.marketplaceExtendedQuery.selectExtendedMarketplaceItem(this.itemId).pipe(tap((item) => {
            if (item) {
                this._setUpLocalVariables(item);
                this._updateMarketplaceItemType(item);
                this._updateTheme(item);
                this._setUpTermsAndConditions(item);
                if (this.marketplaceActionsComponent) {
                    this.marketplaceActionsComponent.updatePurchaseData();
                }
            }
        }));
        this._subToUserChange();
        this.showStockLevel();
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
    submitForm() {
        this.hasSumbittedForm = true;
    }
    onAttributeValueChange(item, attributeSelection) {
        if (!attributeSelection || !attributeSelection.AttributeValues) {
            return;
        }
        this.attributeMappingID = attributeSelection.AttributeMappingId ? attributeSelection.AttributeMappingId : undefined;
        this.selectedAttributes = this.marketplaceExtendedQuery.getSelectedAttributes(item.Id, this.currentLcid, attributeSelection.AttributeValues);
        const useMappings = item.StockType === MarketplaceItemStockType.AttributeStockType &&
            item.AttributeMappings &&
            item.AttributeMappings.length > 0;
        this.availableStock = useMappings ? attributeSelection.AvailableStockCount : this.marketplaceItem.AvailabilityCount;
        this.stockCount = useMappings ? attributeSelection.StockCount : this.marketplaceItem.StockCount;
        const purchaseQuantity = attributeSelection.AvailableStockCount > 0 ? 1 : 0;
        if (this.marketplaceActionsComponent) {
            this.marketplaceActionsComponent.updatePurchaseData(purchaseQuantity, this.attributeMappingID);
        }
    }
    _updateMarketplaceItemType(marketplaceItem) {
        switch (marketplaceItem.ProcessProviderId) {
            case ProcessProviderId.Event:
                this.backLink = '/rewards/events';
                this.marketplaceItemType = 'Event';
                this.marketplaceItemGroup = 'Events';
                break;
            case ProcessProviderId.VirtualEvent:
                this.backLink = '/rewards/events';
                this.marketplaceItemType = 'Event';
                this.marketplaceItemGroup = 'Events';
                break;
            case ProcessProviderId.Product:
                this.backLink = '/rewards/products';
                this.marketplaceItemType = 'Product';
                this.marketplaceItemGroup = 'Products';
                break;
            default:
                this.marketplaceItemType = 'Marketplace';
                this.marketplaceItemGroup = 'Marketplace';
        }
    }
    _updateTheme(marketplaceItem) {
        if (marketplaceItem.Status === MarketplaceItemStatus.Available) {
            this.theme = marketplaceItem.theme;
        }
        else {
            this.theme = 'muted';
        }
    }
    _setUpLocalVariables(item) {
        this.marketplaceItem = item;
        //maintain original item status
        this.originalStatus = item.Status;
        this.availableStock = item.AvailabilityCount;
        this.stockCount = item.StockCount;
    }
    _subToUserChange() {
        this.memberQuery.userContext$
            .pipe(takeUntil(this._destroyed$), map((user) => {
            if (user && user.lcid) {
                this.currentLcid = Number(user.lcid);
            }
        }), tap(() => {
            if (this.marketplaceActionsComponent) {
                this.marketplaceActionsComponent.updatePurchaseData();
            }
        }))
            .subscribe();
    }
    setCustomFields(fields) {
        this.validCustomFields = fields;
        if (this.marketplaceActionsComponent) {
            this.marketplaceActionsComponent.updateCustomFields(fields);
        }
    }
    hasECash() {
        return !!this.marketplaceItem.EcashValue;
    }
    hasMerchant() {
        return !!this.cardTokenCount && !!this.marketplaceItem.MerchantValue;
    }
    showStockLevel() {
        this.translate
            .stream('feature.flag.show.stock')
            .pipe(takeUntil(this._destroyed$))
            .subscribe((data) => {
            if (data === 'false') {
                this.showStock = JSON.parse(data);
            }
        });
    }
    updateLoading(state) {
        this.loading = state;
    }
    _setUpTermsAndConditions(item) {
        this.termsAccepted = !item.TermsAndConditions;
        if (item.TermsAndConditionsType === TermsAndCondtionsType.Text) {
            this.termsLink = this.router.url + '/terms';
        }
        else {
            this.termsLink = item.TermsAndConditions;
        }
    }
    showDescriptionActive() {
        this.showDescription = true;
        this.showTermsAndConditionsText = false;
    }
    showTermsAndConditonsActive() {
        this.showDescription = false;
        this.showTermsAndConditionsText = true;
        scrollTo(0, document.body.scrollHeight);
    }
}
MarketplaceDetailsComponent.ɵfac = function MarketplaceDetailsComponent_Factory(t) { return new (t || MarketplaceDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MarketplaceExtendedQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CardTokenQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService)); };
MarketplaceDetailsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MarketplaceDetailsComponent, selectors: [["fgbcl-marketplace-details"]], viewQuery: function MarketplaceDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MarketplaceActionsComponent, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.marketplaceActionsComponent = _t.first);
    } }, inputs: { actionLabels: "actionLabels", itemId: "itemId" }, decls: 3, vars: 4, consts: [[4, "ngIf"], [1, "container"], [1, "d-block", "d-lg-flex", "mt-lg-3", "pt-lg-3"], [1, "loyalty-details-image", "card", "shadow", "border-0", "rounded", "overflow-hidden", "p-0"], ["draggable", "false", 1, "card-img", 3, "src", "alt", "useDefault", "loyaltyType"], [1, "card-img-overlay", "d-flex", "flex-column", "justify-content-start", "p-0"], [3, "loyaltyType"], [1, "loyalty-details", "w-100"], ["id", "header-name", 1, "marketplace-item-name", "mt-0", "pl-0", "pl-lg-3", "pt-4", "pt-lg-0"], [1, "card-body", "d-flex", "flex-column", "justify-content-between", "pr-3", "pl-0", "pl-lg-3", "pb-4", "pt-2", "pt-lg-3"], [1, "row", "mb-2"], [1, "col-6", "col-lg-4", "d-flex", "align-items-center", "pb-3"], ["role", "img", "aria-label", "Points Value", 1, "icon", "material-icons", "marketplace-icons", "mr-2"], ["id", "points-value", 1, "marketplace-item-details", "pt-1"], ["class", "col-6 col-lg-4 d-flex align-items-center pb-3", 4, "ngIf"], [1, "d-flex", "flex-column", "flex-lg-row", "w-100", 3, "marketplaceItem", "attributeMapping"], [3, "itemCustomFields", "hasSumbittedForm", "customFieldsChange", 4, "ngIf"], [3, "marketplaceItem", "marketplaceItemType", "attributeMappingID", "selectedAttributes", "validCustomFields", "hasECash", "theme", "actionLabels", "availableStock", "purchaseLoading", "hasSumbittedForm", 4, "ngIf"], [1, "navbar", "navbar-default", "pb-0", "pl-0"], [1, "container-fluid", "pl-0"], [1, "nav", "navbar-nav", "flex-row", "mt-4"], [1, "marketplace-item-description", "py-2", "pr-2", "pl-0", "mb-0", "mr-3", "cursor-pointer", 3, "ngClass", "click"], ["class", "marketplace-item-terms py-2 pr-2 pl-0 mb-0 mr-3 cursor-pointer", 3, "ngClass", "click", 4, "ngIf"], [1, "border-top", "border-disabled", "mt-0", "mb-2", "w-100"], ["role", "img", 1, "icon", "material-icons", "marketplace-icons", "mr-2"], ["id", "ecash-value", 1, "marketplace-item-details", "pt-1"], ["id", "merchant-value", 1, "marketplace-item-details", "pt-1"], ["role", "img", 1, "icon", "material-icons", "reward-detail-icons", "marketplace-icons", "mr-2"], ["id", "stock", 1, "marketplace-item-details", "pt-1"], [3, "itemCustomFields", "hasSumbittedForm", "customFieldsChange"], [1, "reward-terms", "mt-2", "mb-3"], ["id", "checkbox", "type", "checkbox", 3, "ngModel", "ngModelChange"], [1, "state"], [1, "marketplace-terms"], [1, "links"], ["id", "link-modal", "class", "cursor-pointer marketplace-terms-link", 3, "click", 4, "ngIf"], ["id", "link-url", "class", "marketplace-terms-link", "target", "_blank", 3, "href", 4, "ngIf"], ["id", "link-modal", 1, "cursor-pointer", "marketplace-terms-link", 3, "click"], ["id", "link-url", "target", "_blank", 1, "marketplace-terms-link", 3, "href"], [3, "marketplaceItem", "marketplaceItemType", "attributeMappingID", "selectedAttributes", "validCustomFields", "hasECash", "theme", "actionLabels", "availableStock", "purchaseLoading", "hasSumbittedForm"], [1, "marketplace-item-terms", "py-2", "pr-2", "pl-0", "mb-0", "mr-3", "cursor-pointer", 3, "ngClass", "click"], ["id", "description", 3, "description"], ["target", "_blank", "class", "font-size-14", 3, "href", 4, "ngIf"], ["id", "termsAndDescription", 3, "description"], ["target", "_blank", 1, "font-size-14", 3, "href"], [1, "full-screen-splash"]], template: function MarketplaceDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MarketplaceDetailsComponent_div_0_Template, 37, 35, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, MarketplaceDetailsComponent_ng_container_2_Template, 3, 0, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.marketplaceItem$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [ɵngcc4.NgIf, ɵngcc5.ImgDefaultDirective, ɵngcc6.LoyaltyIconComponent, ɵngcc7.MarketplaceAttributesComponent, ɵngcc4.NgClass, ɵngcc8.MarketplaceCustomFieldsComponent, ɵngcc9.CheckboxControlValueAccessor, ɵngcc9.NgControlStatus, ɵngcc9.NgModel, ɵngcc10.MarketplaceActionsComponent, ɵngcc11.ShortLongDescriptionComponent, ɵngcc12.LoadingComponent], pipes: [ɵngcc4.AsyncPipe, ɵngcc13.ContentImagePipe, ɵngcc3.TranslatePipe, ɵngcc13.FortressCurrencyPipe, ɵngcc4.DecimalPipe], styles: [".full-screen-splash[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;position:absolute;top:0;bottom:0;left:0;right:0;background-color:hsla(0,0%,100%,.3333333333333333)}.attribute-control[_ngcontent-%COMP%]{height:34px;font-size:.875rem}.links[_ngcontent-%COMP%]{display:inline}"] });
MarketplaceDetailsComponent.ctorParameters = () => [
    { type: MarketplaceExtendedQuery },
    { type: CardTokenQuery },
    { type: MemberQuery },
    { type: Router },
    { type: TranslateService }
];
MarketplaceDetailsComponent.propDecorators = {
    itemId: [{ type: Input }],
    actionLabels: [{ type: Input }],
    marketplaceActionsComponent: [{ type: ViewChild, args: [MarketplaceActionsComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-marketplace-details',
                template: "<div *ngIf=\"marketplaceItem$ | async as item\">\r\n  <div class=\"container\">\r\n    <div class=\"d-block d-lg-flex mt-lg-3 pt-lg-3\">\r\n      <!-- Image -->\r\n      <div class=\"loyalty-details-image card shadow border-0 rounded overflow-hidden p-0\">\r\n        <img\r\n          class=\"card-img\"\r\n          src=\"{{ item.ItemImageURL | contentImage: '7':'marketplace' }}\"\r\n          [alt]=\"item.DisplayName\"\r\n          [useDefault]=\"true\"\r\n          [loyaltyType]=\"'marketplace'\"\r\n          draggable=\"false\"\r\n        />\r\n        <div class=\"card-img-overlay d-flex flex-column justify-content-start p-0\">\r\n          <fgbcl-loyalty-icon\r\n            class=\"corner-icon {{ 'bg-' + item.theme }} {{ 'text-on-' + item.theme }}\"\r\n            [loyaltyType]=\"item.ProcessProviderId\"\r\n          ></fgbcl-loyalty-icon>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Details -->\r\n      <div class=\"loyalty-details w-100\">\r\n        <h2 class=\"marketplace-item-name mt-0 pl-0 pl-lg-3 pt-4 pt-lg-0\" id=\"header-name\">{{ item.DisplayName }}</h2>\r\n\r\n        <!-- Card Body -->\r\n        <div class=\"card-body d-flex flex-column justify-content-between pr-3 pl-0 pl-lg-3 pb-4 pt-2 pt-lg-3\">\r\n          <!-- Item Details -->\r\n          <div class=\"row mb-2\">\r\n            <!-- Points -->\r\n            <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\">\r\n              <span\r\n                class=\"icon material-icons marketplace-icons mr-2\"\r\n                role=\"img\"\r\n                aria-label=\"Points Value\"\r\n                attr.aria-label=\"{{ 'marketplace.points.value.screenreader' | translate }}\"\r\n                >emoji_events</span\r\n              >\r\n              <span class=\"marketplace-item-details pt-1\" id=\"points-value\">{{\r\n                item.PointValue | FortressCurrencyPipe: 'PTS'\r\n              }}</span>\r\n            </div>\r\n\r\n            <!-- Ecash -->\r\n            <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\" *ngIf=\"hasECash()\">\r\n              <span\r\n                class=\"icon material-icons marketplace-icons mr-2\"\r\n                role=\"img\"\r\n                attr.aria-label=\"{{ 'marketplace.details.ecash.screenreader' | translate }}\"\r\n                >attach_money</span\r\n              >\r\n              <span class=\"marketplace-item-details pt-1\" id=\"ecash-value\">{{ item.EcashValue | number }}</span>\r\n            </div>\r\n\r\n            <!-- Merchant -->\r\n            <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\" *ngIf=\"hasMerchant()\">\r\n              <span\r\n                class=\"icon material-icons marketplace-icons mr-2\"\r\n                role=\"img\"\r\n                attr.aria-label=\"{{ 'marketplace.merchant.price.screenreader' | translate }}\"\r\n                >attach_money</span\r\n              >\r\n              <span class=\"marketplace-item-details pt-1\" id=\"merchant-value\">{{\r\n                item.MerchantValue / 100 | FortressCurrencyPipe\r\n              }}</span>\r\n            </div>\r\n\r\n            <!-- Stock -->\r\n            <ng-container *ngIf=\"showStock\">\r\n              <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\" *ngIf=\"!item.ComingSoon\">\r\n                <span\r\n                  class=\"icon material-icons reward-detail-icons marketplace-icons mr-2\"\r\n                  role=\"img\"\r\n                  attr.aria-label=\"{{ 'marketplace.stock.screenreader' | translate }}\"\r\n                  >local_offer</span\r\n                >\r\n                <span class=\"marketplace-item-details pt-1\" id=\"stock\"> {{ availableStock }}/{{ stockCount }} </span>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n\r\n          <fgbcl-marketplace-attributes\r\n            class=\"d-flex flex-column flex-lg-row w-100\"\r\n            [marketplaceItem]=\"item\"\r\n            (attributeMapping)=\"onAttributeValueChange(item, $event)\"\r\n          ></fgbcl-marketplace-attributes>\r\n\r\n          <!--Custom Fields-->\r\n          <fgbcl-marketplace-custom-fields\r\n            *ngIf=\"item.CustomFields && item.CustomFields.length > 0\"\r\n            [itemCustomFields]=\"item.CustomFields\"\r\n            [hasSumbittedForm]=\"hasSumbittedForm\"\r\n            (customFieldsChange)=\"setCustomFields($event)\"\r\n          >\r\n          </fgbcl-marketplace-custom-fields>\r\n\r\n          <!--Terms and Condtions Checkbox-->\r\n          <div *ngIf=\"marketplaceItem.ShowTermsAndConditions\">\r\n            <!-- <hr class=\"border-top border-disabled mt-0 mb-3 w-100\" /> -->\r\n            <div class=\"reward-terms mt-2 mb-3\">\r\n              <input\r\n                id=\"checkbox\"\r\n                type=\"checkbox\"\r\n                [(ngModel)]=\"termsAccepted\"\r\n                (ngModelChange)=\"marketplaceActionsComponent.updateTermsAndCondtions($event)\"\r\n              />\r\n              <div class=\"state\">\r\n                <label class=\"marketplace-terms\">{{ 'marketplace.terms.accept' | translate }} </label>\r\n              </div>\r\n            </div>\r\n            <div class=\"links\">\r\n              <a\r\n                id=\"link-modal\"\r\n                (click)=\"showTermsAndConditonsActive()\"\r\n                *ngIf=\"marketplaceItem.TermsAndConditionsType === TermsAndCondtionsType.Text\"\r\n                class=\"cursor-pointer marketplace-terms-link\"\r\n              >\r\n                {{ 'marketplace.terms.tcs' | translate }}\r\n              </a>\r\n              <a\r\n                id=\"link-url\"\r\n                class=\"marketplace-terms-link\"\r\n                target=\"_blank\"\r\n                *ngIf=\"marketplaceItem.TermsAndConditionsType === TermsAndCondtionsType.URL\"\r\n                [href]=\"termsLink\"\r\n              >\r\n                {{ 'marketplace.terms.tcs' | translate }}\r\n              </a>\r\n            </div>\r\n            <!-- <hr class=\"border-top border-disabled mt-3 mb-2 w-100\" /> -->\r\n          </div>\r\n\r\n          <!-- Bottom Buttons -->\r\n          <fgbcl-marketplace-actions\r\n            *ngIf=\"item\"\r\n            [marketplaceItem]=\"item\"\r\n            [marketplaceItemType]=\"marketplaceItemType\"\r\n            [attributeMappingID]=\"attributeMappingID\"\r\n            [selectedAttributes]=\"selectedAttributes\"\r\n            [validCustomFields]=\"validCustomFields\"\r\n            [hasECash]=\"hasECash()\"\r\n            [theme]=\"theme\"\r\n            [actionLabels]=\"actionLabels\"\r\n            [availableStock]=\"availableStock\"\r\n            (purchaseLoading)=\"updateLoading($event)\"\r\n            (hasSumbittedForm)=\"submitForm()\"\r\n          >\r\n          </fgbcl-marketplace-actions>\r\n\r\n          <!-- Description & Terms Nav -->\r\n          <nav class=\"navbar navbar-default pb-0 pl-0\">\r\n            <div class=\"container-fluid pl-0\">\r\n              <ul class=\"nav navbar-nav flex-row mt-4\">\r\n                <li\r\n                  (click)=\"showDescriptionActive()\"\r\n                  class=\"marketplace-item-description py-2 pr-2 pl-0 mb-0 mr-3 cursor-pointer\"\r\n                  [ngClass]=\"showDescription ? 'text-primary' : 'text-info'\"\r\n                >\r\n                  {{ 'marketplace.item.description' | translate }}\r\n                </li>\r\n                <li\r\n                  (click)=\"showTermsAndConditonsActive()\"\r\n                  *ngIf=\"marketplaceItem.ShowTermsAndConditions\"\r\n                  class=\"marketplace-item-terms py-2 pr-2 pl-0 mb-0 mr-3 cursor-pointer\"\r\n                  [ngClass]=\"showTermsAndConditionsText ? 'text-primary' : 'text-info'\"\r\n                >\r\n                  {{ 'marketplace.item.tcs' | translate }}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </nav>\r\n          <hr class=\"border-top border-disabled mt-0 mb-2 w-100\" />\r\n          <div *ngIf=\"showDescription\">\r\n            <fgbcl-short-long-description id=\"description\" [description]=\"item.DescriptionText\"> </fgbcl-short-long-description>\r\n          </div>\r\n          <div *ngIf=\"showTermsAndConditionsText\">\r\n            <div *ngIf=\"marketplaceItem.TermsAndConditionsType === TermsAndCondtionsType.Text\">\r\n              <fgbcl-short-long-description id=\"termsAndDescription\" [description]=\"item.TermsAndConditions\">\r\n              </fgbcl-short-long-description>\r\n            </div>\r\n            <a\r\n              *ngIf=\"marketplaceItem.TermsAndConditionsType === TermsAndCondtionsType.URL\"\r\n              [href]=\"item.TermsAndConditions\"\r\n              target=\"_blank\"\r\n              class=\"font-size-14\"\r\n              >{{ item.TermsAndConditions }}</a\r\n            >\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-container *ngIf=\"loading\">\r\n  <div class=\"full-screen-splash\">\r\n    <fgbcl-loading></fgbcl-loading>\r\n  </div>\r\n</ng-container>\r\n",
                styles: [".full-screen-splash{display:flex;align-items:center;justify-content:center;position:absolute;top:0;bottom:0;left:0;right:0;background-color:hsla(0,0%,100%,.3333333333333333)}.attribute-control{height:34px;font-size:.875rem}.links{display:inline}"]
            }]
    }], function () { return [{ type: ɵngcc1.MarketplaceExtendedQuery }, { type: ɵngcc1.CardTokenQuery }, { type: ɵngcc1.MemberQuery }, { type: ɵngcc2.Router }, { type: ɵngcc3.TranslateService }]; }, { actionLabels: [{
            type: Input
        }], itemId: [{
            type: Input
        }], marketplaceActionsComponent: [{
            type: ViewChild,
            args: [MarketplaceActionsComponent]
        }] }); })();

class MarketplaceDetailsModule {
}
MarketplaceDetailsModule.ɵfac = function MarketplaceDetailsModule_Factory(t) { return new (t || MarketplaceDetailsModule)(); };
MarketplaceDetailsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MarketplaceDetailsModule });
MarketplaceDetailsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PipesModule,
            LoadingModule,
            ShortLongDescriptionModule,
            LoyaltyIconModule,
            DirectivesModule,
            FormsModule,
            MarketplaceActionsModule,
            MarketplaceAttributesModule,
            MarketplaceCustomFieldsModule,
            MarketplacePurchaseConfirmationModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MarketplaceDetailsModule, { declarations: function () { return [MarketplaceDetailsComponent]; }, imports: function () { return [CommonModule,
        PipesModule,
        LoadingModule,
        ShortLongDescriptionModule,
        LoyaltyIconModule,
        DirectivesModule,
        FormsModule,
        MarketplaceActionsModule,
        MarketplaceAttributesModule,
        MarketplaceCustomFieldsModule,
        MarketplacePurchaseConfirmationModule, ɵngcc3.TranslateModule]; }, exports: function () { return [MarketplaceDetailsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [MarketplaceDetailsComponent],
                imports: [
                    CommonModule,
                    PipesModule,
                    LoadingModule,
                    ShortLongDescriptionModule,
                    LoyaltyIconModule,
                    DirectivesModule,
                    FormsModule,
                    MarketplaceActionsModule,
                    MarketplaceAttributesModule,
                    MarketplaceCustomFieldsModule,
                    MarketplacePurchaseConfirmationModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MarketplaceDetailsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MarketplaceDetailsComponent, MarketplaceDetailsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-marketplace-marketplace-details.js.map